import * as React from "react";

/** 간단한 className 머지 */
function cn(...xs: Array<string | false | undefined>) {
  return xs.filter(Boolean).join(" ");
}

/** 스크롤 내려가면 elevation 주기 */
function useElevatedOnScroll(threshold = 2) {
  const [elevated, setElevated] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return elevated;
}

type AppBarProps = {
  title?: string;
  /** 좌측 뒤로가기 사용 여부 (기본 true) */
  backButton?: boolean;
  /** 투명 배경(콘텐츠 위에 overlay) */
  transparent?: boolean;
  /** 우측 액션 영역 */
  right?: React.ReactNode;
  /** 고정 높이(기본 56) */
  height?: number;
  className?: string;
  /** 커스텀 클릭 핸들러(뒤로가기 대신) */
  onBack?: () => void;
};

export default function TermsAppbar({
  title,
  transparent = false,
  className,
  onBack,
}: AppBarProps) {
  const elevated = useElevatedOnScroll(2);

  return (
    <header
      className={cn(
        "sticky top-0 z-40",
        transparent ? "border-transparent" : "bg-white/90 backdrop-blur",
        !transparent && (elevated ? "shadow-sm" : "shadow-none"),
        className,
      )}
      // iOS 노치 대응: 안전하게 safe-area 상단 패딩 더해줌
      style={{
        paddingTop: "var(--safe-area-inset-top)",
      }}
    >
      <div
        className="mx-auto w-full items-center"
        style={{
          display: "grid",
          gridTemplateColumns: "56px 1fr auto",
        }}
      >
        {/* Left */}
        <div className="flex items-center justify-end gap-1"></div>

        {/* Center Title */}
        <div className="flex items-center justify-center">
          {title ? (
            <h1 className="line-clamp-1 text-base font-bold text-black text-center">
              {title}
            </h1>
          ) : null}
        </div>

        {/* Right actions */}
        <button
          aria-label="뒤로가기"
          onClick={onBack}
          className="px-[12px] h-fit py-[10px] hover:bg-black/5 active:bg-black/10 font-[500] text-sm  my-1"
        >
          <img
            className="size-5 cursor-pointer"
            src="/icons/ic-x.png"
            role="button"
          />
        </button>
      </div>
      {/* safe bottom border gradient for transparent bars if needed */}
      {transparent ? (
        <div className="h-px bg-gradient-to-r from-black/10 to-transparent" />
      ) : null}
    </header>
  );
}
